import React from 'react';
import './ModalDialog.css';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import CloseIconBlack from '../../assets/icons/close-grey.svg';

function ModalDialog(props) {
  const {
    showDialog,
    onClose,
    onClickSecondary,
    heading,
    dialogContent,
    closeButtonText,
    secondaryButtonText,
    hasCloseIcon,
    hasCloseButton,
    hasSecondaryButton,
    dialogBoxClasses,
    headingClasses,
    modalType
  } = props;
  return (
    <Modal show={showDialog} onHide={onClose} size='sm' centered='true' className='prequal--web--modal-dialog'>
      <Modal.Body data-testid='modal-body'>
        <div id='prequal--web--app'>
          <main className='prequal--web--app prequal--wc--app'>
            <div className='prequal--web--form-container prequal--web--dialog-content-padding'>
              <div
                data-testid={`OverlayModalDialog${modalType}`}
                id={`OverlayModalDialog${modalType}`}
                aria-modal='true'
                aria-label='Offer Details'
              >
                <div className={dialogBoxClasses}>
                  <div className='prequal--web--modal-close-button'>
                    {hasCloseIcon ? (
                      <button onClick={onClose} data-testid='closeButton' onKeyDown={onClose} id={`closeButton${modalType}`} type='button'>
                        <img src={CloseIconBlack} alt='close' />
                      </button>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className={`prequal--web--modal-dialog-heading ${headingClasses}`}>{heading}</div>
                  {dialogContent}
                  <div className='prequal--web--button-container'>
                    {hasCloseButton && (
                      <div>
                        <button
                          onClick={onClose}
                          type='button'
                          data-testid='closeTextButton'
                          className='prequal--web--close-text-button prequal--web--submit-prequalification-button'
                        >
                          {closeButtonText}
                        </button>
                      </div>
                    )}
                    {hasSecondaryButton && (
                      <div>
                        <button
                          onClick={onClickSecondary}
                          type='button'
                          data-testid='secondaryTextButton'
                          className='prequal--web--secondary-button prequal--web--secondary-text-button'
                        >
                          {secondaryButtonText}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </Modal.Body>
    </Modal>
  );
}

ModalDialog.propTypes = {
  showDialog: PropTypes.bool,
  onClose: PropTypes.func,
  heading: PropTypes.string,
  dialogContent: PropTypes.object,
  closeButtonText: PropTypes.string,
  hasCloseIcon: PropTypes.bool,
  hasCloseButton: PropTypes.bool,
  dialogBoxClasses: PropTypes.string,
  headingClasses: PropTypes.string,
  modalType: PropTypes.string
};

ModalDialog.defaultProps = {
  showDialog: false,
  onClose: null,
  heading: '',
  dialogContent: null,
  hasCloseIcon: true,
  hasCloseButton: true,
  dialogBoxClasses: '',
  headingClasses: '',
  closeButtonText: 'Close',
  modalType: ''
};

export default ModalDialog;
